namespace TabAurous.Purchase {
    export namespace OpenConsignmentInBifurcationService {
        export const baseUrl = 'Purchase/OpenConsignmentInBifurcation';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Reports.StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/OpenConsignmentInBifurcation/List",
            PartyList = "Purchase/OpenConsignmentInBifurcation/PartyList",
            ProductList = "Purchase/OpenConsignmentInBifurcation/ProductList"
        }

        [
            'List', 
            'PartyList', 
            'ProductList'
        ].forEach(x => {
            (<any>OpenConsignmentInBifurcationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
